import React from "react";

function FormInput({
  input,
  inputId,
  inputLabel,
  inputPlaceholder,
  helpText,
  onInput,
}: {
  input: string;
  inputId: string;
  inputLabel: string;
  inputPlaceholder: string;
  helpText?: string;
  onInput(value: React.FormEvent<HTMLInputElement>): void;
}) {
  return (
    <div className="form-box pb-4">
      <label htmlFor={inputId} className="text-small font-medium pb-1">
        {inputLabel}
      </label>
      <input
        id={inputId}
        type="text"
        className="border-gray rounded"
        value={input}
        placeholder={inputPlaceholder}
        onInput={onInput}
      />
      {helpText ? (
        <p className="text-xsmall font-gray py-1">{helpText}</p>
      ) : null}
    </div>
  );
}

export default FormInput;
